import { Component } from 'react';
import { Container, Row, Col, Alert } from 'react-bootstrap';

class RestrictedAccess extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Container className="mt-5">
        <Row className="justify-content-md-center">
          <Col md={8}>
            <Alert variant="danger" className="shadow-sm border-left-strong">
              <Alert.Heading className="d-flex align-items-center">
                Restricted Access
              </Alert.Heading>
              <p>
                You do not have the necessary permissions to view or edit this lead.
              </p>
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default RestrictedAccess;